import { render, staticRenderFns } from "./FlightBoxOneApp.vue?vue&type=template&id=5d27990b&scoped=true"
import script from "./FlightBoxOneApp.vue?vue&type=script&lang=js"
export * from "./FlightBoxOneApp.vue?vue&type=script&lang=js"
import style0 from "./FlightBoxOneApp.vue?vue&type=style&index=0&id=5d27990b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d27990b",
  null
  
)

export default component.exports